import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {Col, Container, Row} from 'react-bootstrap';

import {service as PermitService} from "../../../Services/PermitService";
import {useCheckAuth} from "../../../Hooks/RouteHooks";
import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {PermitsTable} from "./Table";
import {PermitsTableFilter} from "./TableFilter";

export const PermitsIndexPage = props => {
    useCheckAuth();
    const classNames = useClassNames('sb-permits-index-page');
    const makePageRequest = useMakePageRequest();

    const contextNodeId = useSelector(state => state.contextState.context.contextNodeId);
    const [permits, setPermits] = useState([]);

    useEffect(() => {
        if (contextNodeId) {
            makePageRequest(
                () => PermitService.GetPermitsForContext(contextNodeId),
                ({result}) => {
                    let permitResults = [];

                    result.forEach(permit => {
                        permit.ConservationActionPermits.forEach(caPermit => {
                            permitResults = [...permits, {
                                ...permit,
                                conservationActionName: caPermit?.ConservationAction?.ContextNodeDetails?.name,
                                link: caPermit?.ConservationAction?.ContextNodeDetails?.link,
                            }];
                        })
                    });

                    setPermits(permitResults);
                }
            );
        }
    }, [contextNodeId]);

    return <Container className={classNames}>
        <Row>
            <Col xs={12} md={6}><h2>Permits</h2></Col>
            {/*<Col xs={12} md={6}>*/}
                {/*<StreamBankLink Tool="permits/new">*/}
                    {/*<Button variant="link" className="float-right h3">*/}
                        {/*<Glyphicon glyph="plus-sign" />Add Permit*/}
                    {/*</Button>*/}
                {/*</StreamBankLink>*/}
            {/*</Col>*/}
        </Row>
        <Row>
            <Col xs={12}>
                <hr className="special-hr"/>
            </Col>
        </Row>
        <Row>
            <Col xs={12}>
                <PermitsTable
                    FilterComponent={PermitsTableFilter}
                    Data={permits}
                />
            </Col>
        </Row>
    </Container>;
};


